/* eslint-disable class-methods-use-this */
export default class LandingPageView {
  show() {
    document.getElementById('landing-page').style.display = 'flex';
    document.getElementById('resultado-pesquisa').style.display = 'none';
    document.querySelector('.header__logo img').style.display = 'none';
  }
}
